/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondFriendRequestBody
 */
export interface RespondFriendRequestBody {
    /**
     * The user ID who sent the friend request
     * @type {string}
     * @memberof RespondFriendRequestBody
     */
    requesterId: string;
    /**
     * Whether to accept or decline the request
     * @type {string}
     * @memberof RespondFriendRequestBody
     */
    action: RespondFriendRequestBodyActionEnum;
}


/**
 * @export
 */
export const RespondFriendRequestBodyActionEnum = {
    accept: 'accept',
    decline: 'decline'
} as const;
export type RespondFriendRequestBodyActionEnum = typeof RespondFriendRequestBodyActionEnum[keyof typeof RespondFriendRequestBodyActionEnum];


/**
 * Check if a given object implements the RespondFriendRequestBody interface.
 */
export function instanceOfRespondFriendRequestBody(value: object): value is RespondFriendRequestBody {
    if (!('requesterId' in value) || value['requesterId'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function RespondFriendRequestBodyFromJSON(json: any): RespondFriendRequestBody {
    return RespondFriendRequestBodyFromJSONTyped(json, false);
}

export function RespondFriendRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondFriendRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'requesterId': json['requesterId'],
        'action': json['action'],
    };
}

export function RespondFriendRequestBodyToJSON(json: any): RespondFriendRequestBody {
    return RespondFriendRequestBodyToJSONTyped(json, false);
}

export function RespondFriendRequestBodyToJSONTyped(value?: RespondFriendRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requesterId': value['requesterId'],
        'action': value['action'],
    };
}

